exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".slick-slider[data-v-e1166f76] {\n  height: 100%;\n}", ""]);

// exports
